import {Observable} from "rxjs/Observable";
import {ServiceConfig} from "../app/services-config";
import {HttpService} from "./http.service";

export class ResourceService {
  constructor(private httpService: HttpService, private listUrl: string, private detailUrl: string) {
  }

  getAll(params?: any): Observable<any> {
    return this.httpService.get(this.listUrl, params).map(response => response.json());
  }

  getOne(id): Observable<any> {
    return this.httpService.get(this.detailUrl.replace("{id}", id)).map(response => response.json());
  }

  getCategories(params?: any): Observable<any> {
    return this.httpService.get(this.listUrl + ServiceConfig.categorySuffix, params).map(response => response.json());
  }

  store(data?: any): Observable<any> {
    return this.httpService.post(this.listUrl, data).map(response => response.json());
  }

  update(id, data?: any): Observable<any> {
    const url = this.detailUrl.replace("{id}", id);

    if (data instanceof FormData) {
      data.append('_method', 'PUT');
      return this.httpService.post(url, data).map(response => response.json());
    }

    return this.httpService.put(url, data).map(response => response.json());
  }
}



// WEBPACK FOOTER //
// ./src/services/resource.service.ts